import React, {useState} from 'react';
import {Button, COLORS, FONTS, SIZES, Typography} from '@fupa/fupa-uikit';
import {authorizedAPI} from 'app/services/api';
import {RequestErrorHandler, Information, Container} from 'app/components/match/matchLive/LivetickerCommon';
import {LoadingButton} from '@mui/lab';
import {styled} from '@mui/material/styles';

const StyledLoadingButton = styled(LoadingButton)({
  color: COLORS.fupaSecondary,
  fontFamily: FONTS.PTSans,
  textTransform: 'initial',
  padding: `${SIZES['1']} ${SIZES['6']} ${SIZES['1']} ${SIZES['8']}`,
  lineHeight: SIZES['20'],
});

const StyledTypography = styled(Typography)`
  &&& {
    display: flex;
    align-items: center;
  }
`;

const deleteTicker = slug => {
  return authorizedAPI.delete(`/matches/${slug}/ticker`);
};

const LivetickerAssigned = ({match, reloadData, setPermissions}) => {
  const [error, setError] = useState(null);
  const [isSigningOut, setIsSigningOut] = useState(false);

  const handleTickerSignOut = async () => {
    setIsSigningOut(true);
    try {
      await deleteTicker(match.slug);
      setPermissions({});
      setIsSigningOut(false);
      reloadData();
    } catch (error) {
      setIsSigningOut(false);
      setError(RequestErrorHandler(error, match.slug));
    }
  };

  const errorMessage = error ? (
    <>
      <br />
      <Typography variant='caption-error'>{error?.message}</Typography>
    </>
  ) : null;

  const ButtonToLiveticker = (
    <a href={`${process.env.ADMIN_URL}/fupa/admin/user_liveticker_popup_new.php?match_id=${match.id}`} target='_blank'>
      <Button label='Zur Liveticker-Maske' />
    </a>
  );

  if (match.section === 'PRE') {
    return (
      <Container>
        <Information>
          <Typography variant='body1'>Du hast dich erfolgreich als Liveticker-Melder eingetragen! 💪</Typography>
        </Information>
        {ButtonToLiveticker}
        <Information margin>
          <StyledTypography variant='body1' component='div'>
            Doch keine Zeit?
            <StyledLoadingButton onClick={handleTickerSignOut} loading={isSigningOut}>
              Als Liveticker-Melder austragen
            </StyledLoadingButton>
          </StyledTypography>
          {errorMessage}
        </Information>
      </Container>
    );
  }
  return <Container>{ButtonToLiveticker}</Container>;
};

export default LivetickerAssigned;
